/**
 * The edition this build is made for (docs/EDITIONS.md): the `ORBITA_EDITION` the build ran with, empty for the base
 * product (vite.config.ts → `__APP_EDITION__`).
 */
export const APP_EDITION: string = __APP_EDITION__;

/**
 * True for a file of an edition other than this build's: `src/editions/<name>/…` where `<name>` is not `APP_EDITION`. The
 * base product has no `src/editions` at all (web/Dockerfile removes it), so in a production build this only ever sees
 * files of the edition being built; the check keeps a development server of the base product honest while an edition's
 * folder is on disk.
 */
export function isOtherEditionPath(path: string): boolean {
  const edition = /\/editions\/([^/]+)\//u.exec(path)?.[1];
  return edition !== undefined && edition !== APP_EDITION;
}
